import React, { useEffect, useState, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';
import { isManager } from '../../utils/roles';
import FunderLetterHeader from '../../components/financial/FunderLetterHeader';
import MonthSwitcher from '../../components/financial/MonthSwitcher';
import OverallSummaryTable from '../../components/financial/OverallSummaryTable';

export default function ReportCover() {
  const { funderId, month } = useParams();
  const { api, user } = useAuth();
  const toast = useToast();
  const [periods, setPeriods] = useState([]);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const manager = isManager(user);

  const load = useCallback(() => {
    setLoading(true);
    api(`/financial/funders/${funderId}/periods`)
      .then((ps) => {
        setPeriods(ps);
        const cur = ps.find((p) => p.report_month === month) || ps[0];
        if (!cur) { setData(null); return null; }
        return api(`/financial/periods/${cur.id}`).then((d) => setData({ ...d, _periodId: cur.id }));
      })
      .catch((e) => toast.error(e.message))
      .finally(() => setLoading(false));
  }, [funderId, month, api, toast]);

  useEffect(() => { load(); }, [load]);

  const publish = async () => {
    try {
      await api(`/financial/periods/${data._periodId}/publish`, { method: 'PUT' });
      toast.success('تم نشر التقرير');
      load();
    } catch (e) { toast.error(e.message); }
  };

  if (loading) return <div className="loader">جاري التحميل...</div>;
  if (!data) return <div className="empty">لا يوجد تقرير لهذا الشهر</div>;

  return (
    <div>
      <Link to="/financial-reports" style={{ fontSize: 13, color: 'var(--text-muted)', display: 'inline-block', marginBottom: 8 }}>← الجهات</Link>

      <FunderLetterHeader funder={data.funder} period={data.period} />
      <MonthSwitcher periods={periods} funderId={funderId} current={month} />

      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        <a className="btn btn-outline btn-sm" href={`/financial-reports/${funderId}/${month}/print`} target="_blank" rel="noreferrer">🖨 طباعة / PDF</a>
        {manager && data.period.status === 'draft' && (
          <button className="btn btn-success btn-sm" onClick={publish}>✓ نشر التقرير</button>
        )}
      </div>

      <OverallSummaryTable summary={data.summary} funderId={funderId} month={month} />
    </div>
  );
}
